/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraThreatsTrendListRequest {
    getFixupPrototypeFunction() { return InfraThreatsTrendListRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraThreatsTrendListRequest>): InfraThreatsTrendListRequest {
        let obj = Object.assign(new InfraThreatsTrendListRequest(), model);
        InfraThreatsTrendListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraThreatsTrendListRequest>): InfraThreatsTrendListRequest {
        if (!model) return null;
        return InfraThreatsTrendListRequest.newInstance(<InfraThreatsTrendListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraThreatsTrendListRequest) {
        if (!obj) return;

        models.InfraThreatsTrendListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraThreatsTrendListRequest): boolean {
        Object.setPrototypeOf(obj, InfraThreatsTrendListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.InfraThreatsTrendListRequestFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.InfraThreatsTrendListFiltersSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.InfraThreatsTrendListFiltersSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.InfraThreatsTrendListRequestFilters;

}
